import StandardButton from './StandardButton'
export default StandardButton
